import { combineReducers } from 'redux';

import EditDailyDeposit from './editdailydeposit/reducer';
import ModifyDailyDepositGrid from './modifydailydepositgrid/reducer';

export default combineReducers({
  ModifyDailyDepositGrid,
  EditDailyDeposit,
});



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/state/reducer.js